<template>
  <main>
    <v-toolbar class="blue-grey" app fixed dark>
      <v-toolbar-side-icon @click.stop="$root.$children[0]._data.drawer = !$root.$children[0]._data.drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-if="currentDataset.meta.name">Anonymisierung: {{ currentDataset.meta.name }}</v-toolbar-title>
      <v-toolbar-title v-else>Anonymisierung</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>search</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content v-if="currentDataset.meta.name">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 sm4 lg3>
            <v-layout row>
              <v-flex xs12>
                <search-datasets :loading="loadingDatasetIndicator" :datasetsMeta="datasetsMeta.data"></search-datasets>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm8 lg9>
            <v-card>
              <v-toolbar dark class="cyan elevation-0">
                <v-toolbar-title class="white--text">Anonymisierung</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click.native="colorisePrivacyCells" :loading="loadingColorisingCells">
                  <v-icon left>select_all</v-icon>
                  Personenbezogene Daten markieren
                </v-btn>
                <v-btn flat @click.native="anonymiseCells" :disabled="!colorisedPrivacyCells" :loading="loadingAnonymisingCells">
                  <v-icon left>fingerprint</v-icon>
                  Anonymisieren
                </v-btn>
                <v-btn icon @click.native="clearFormatting" :loading="refreshingTable">
                  <v-icon>refresh</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-title primary-title>
                <div>
                  <div class="body-2 grey--text">Wählen Sie eine der Funktionen aus, um fortzufahren.</div>
                </div>
              </v-card-title>

              <v-card-text v-if="loadingDatasetIndicator" style="height: 500px">
                <v-progress-circular indeterminate class="loading-dataset-indicator"></v-progress-circular>
              </v-card-text>

              <v-card-text v-else-if="!currentDataset.dataset.data" style="height: 500px;">
                Keine Daten
              </v-card-text>

              <v-card-text v-else>
                <Spreadsheet :root="root" :settings="currentDataset.dataset" ref="spread"></Spreadsheet>
              </v-card-text>
              <v-card-actions>
                <v-btn flat color="primary">Änderungen speichern</v-btn>
                <v-btn flat>Abbrechen</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-content v-else>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs12>
                <search-datasets :loading="loadingDatasetIndicator" :datasetsMeta="datasetsMeta.data" :show-hint="true"></search-datasets>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
          
  </main>
</template>

<script>
import Spreadsheet from 'vue-handsontable-official'
import IntelligentMetadataScanner from '@/components/IntelligentMetadataScanner'
import SearchDatasets from '@/components/SearchDatasets'

export default {
  computed: {
    currentDataset () {
      return this.$store.getters.getCurrentDataset
    },
    datasetsMeta () {
      return this.$store.getters.getDatasetsMeta
    },
    loadingDatasetIndicator () {
      return this.$store.getters.getLoadingDatasetIndicator
    }
  },
  components: {
    Spreadsheet,
    IntelligentMetadataScanner,
    SearchDatasets
  },
  data () {
    return {
      loadingColorisingCells: false,
      loadingAnonymisingCells: false,
      colorisedPrivacyCells: false,
      anonymisedPrivacyCells: false,
      refreshingTable: false,
      root: 'test-hot'
    }
  },
  methods: {
    colorisePrivacyCells: function () {
      let table = this.$refs.spread.table

      this.loadingColorisingCells = true
      let numberOfRows = (table.countRows() - 1)
      var that = this
      setTimeout(function () {
        for (var i = numberOfRows; i >= 0; i--) {
          table.getCell(i, 0).style.backgroundColor = 'orange'
          table.getCell(i, 0).style.fontWeight = 'bold'
        }
        that.loadingColorisingCells = false
        that.colorisedPrivacyCells = true
      }, 600)
    },
    anonymiseCells: function () {
      let table = this.$refs.spread.table

      this.loadingAnonymisingCells = true
      let numberOfRows = (table.countRows() - 1)
      var that = this
      setTimeout(function () {
        that.currentDataset.dataset.colHeaders.splice(0, 1)
        that.currentDataset.dataset.minRows = 30
        for (var i = numberOfRows; i >= 0; i--) {
          that.currentDataset.dataset.data[i].splice(0, 1)
        }
        that.loadingAnonymisingCells = false
        that.colorisedPrivacyCells = false
        that.anonymisedPrivacyCells = true

        that.currentDataset.meta.status.stepAnonymisierung = true
        that.currentDataset.meta.status.visibility = 'Zur Überprüfung freigegeben'
        that.$store.dispatch('addNotification', {
          title: 'Zur Überprüfung freigegeben',
          text: 'Datensatz ' + that.currentDataset.meta.name.substring(0, 10) + '...' + ' wurde zur Überprüfung freigeben.',
          action: '/erfassung/' + that.currentDataset.meta.id
        })
      }, 600)
    },
    clearFormatting: function () {
      let table = this.$refs.spread.table

      this.refreshingTable = true
      var that = this
      setTimeout(function () {
        table.render()
        that.refreshingTable = false
      }, 400)
    }
  }
}
</script>

<style>
#test-hot {
  height: 400px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/Anonymisierung.vue